import {
  AccordionContent,
  DateTimeValidationType,
  Field,
  FieldSubtype,
  FieldType,
  TEXT_STYLE,
  TextStyle,
} from "@/core/types/types";

export enum FieldName {
  GenericAlternativeTransport = "genericAlternativeTransport",
  FlightPickerHint = "flightPickerHint",
  ManualFlightNumber = "manualFlightNumber",
  FlightPickerAccordion = "flightPickerAccordion",
  ManualDepartureLabel = "manualDepartureLabel",
  ManualDepartureDateTime = "manualDepartureDateTime",
  ManualArrivalLabel = "manualArrivalLabel",
  ManualArrivalDateTime = "manualArrivalDateTime",
}

export const TRANSPORT_ORDER_PLACEHOLDER: string = "transportOrder";
export const FIELD_KEY: string = "fieldKey";
export const FLIGHT_NUMBER_REGEX: string =
  "^([A-Za-z]{2,3}|[A-Za-z]\\d|\\d[A-Z])(\\d{1,4})$";

const fields: { [key in FieldName]: Field } = {
  [FieldName.GenericAlternativeTransport]: {
    id: `${FIELD_KEY}[${TRANSPORT_ORDER_PLACEHOLDER}]`,
    key: `${FIELD_KEY}[${TRANSPORT_ORDER_PLACEHOLDER}]`,
    label: "",
    type: "",
    properties: {},
  },
  [FieldName.FlightPickerHint]: {
    text: "flightPicker.hint",
    type: FieldType.Text,
    id: FieldName.FlightPickerHint,
    key: FieldName.FlightPickerHint,
    label: "",
    properties: {
      subtype: FieldSubtype.Subtitle,
      [TEXT_STYLE]: TextStyle.Bold,
    },
  },
  [FieldName.ManualFlightNumber]: {
    label: "flightPicker.manual.flightNumber.label",
    type: FieldType.TextField,
    id: FieldName.ManualFlightNumber,
    key: FieldName.ManualFlightNumber,
    validate: {
      required: true,
      regex: FLIGHT_NUMBER_REGEX,
    },
    properties: {},
  },
  [FieldName.FlightPickerAccordion]: {
    text: "flightPicker.accordion",
    type: FieldType.Text,
    id: FieldName.FlightPickerAccordion,
    key: FieldName.FlightPickerAccordion,
    label: "",
    properties: {
      subtype: FieldSubtype.Accordion,
      content: AccordionContent.FlightNumber,
    },
  },
  [FieldName.ManualDepartureLabel]: {
    text: "flightPicker.manual.departure.label",
    type: "text",
    id: FieldName.ManualDepartureLabel,
    key: FieldName.ManualDepartureLabel,
    label: "",
    properties: {
      [TEXT_STYLE]: TextStyle.Bold,
    },
  },
  [FieldName.ManualDepartureDateTime]: {
    label: "flightPicker.manual.departureDateTime.label",
    type: FieldType.TextField,
    id: FieldName.ManualDepartureDateTime,
    key: FieldName.ManualDepartureDateTime,
    validate: {
      required: true,
    },
    defaultValue: "departureDate",
    properties: {
      subtype: FieldSubtype.DateTime,
      disableFutureDates: false,
    },
  },
  [FieldName.ManualArrivalLabel]: {
    text: "flightPicker.manual.arrival.label",
    type: FieldType.Text,
    id: FieldName.ManualArrivalLabel,
    key: FieldName.ManualArrivalLabel,
    label: "",
    properties: {
      [TEXT_STYLE]: TextStyle.Bold,
    },
  },
  [FieldName.ManualArrivalDateTime]: {
    label: "flightPicker.manual.arrivalDateTime.label",
    type: FieldType.TextField,
    id: "Field_arrival",
    key: FieldName.ManualArrivalDateTime,
    validate: {
      required: true,
    },
    defaultValue: "departureDate",
    properties: {
      subtype: FieldSubtype.DateTime,
      disableFutureDates: false,
      [DateTimeValidationType.After]: `manualTransports[${TRANSPORT_ORDER_PLACEHOLDER}].manualDepartureDateTime`,
    },
  },
};

export default fields;
